module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.ee7b96fa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Bold.ttf
// module id = 550
// module chunks = 9